import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { obtenerCategorias } from '../services/categoriasService';
import { mensajeAmigable } from '../utils/errores';

// Carga las categorías del negocio una sola vez y las comparte
// con toda la app. Antes estaban hardcodeadas en utils/categorias.js.

const CategoriasContext = createContext(null);

export function CategoriasProvider({ children }) {
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const recargar = useCallback(async () => {
    setCargando(true);
    setError(null);
    try {
      setCategorias(await obtenerCategorias());
    } catch (e) {
      setError(mensajeAmigable(e));
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    recargar();
  }, [recargar]);

  return (
    <CategoriasContext.Provider value={{ categorias, cargando, error, recargar }}>
      {children}
    </CategoriasContext.Provider>
  );
}

export function useCategorias() {
  const ctx = useContext(CategoriasContext);
  if (!ctx) throw new Error('useCategorias debe usarse dentro de <CategoriasProvider>');
  return ctx;
}
